<script>
import moment from 'moment';

export default {
  name: 'RbxDatePicker',
  props: {
    /* Date value in the format yyyy-MM-dd. */
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      date: this.value,
      showDateMenu: false,
    };
  },
  computed: {
    formattedDate() {
      return this.date ? moment(this.date).format('DD.MM.YYYY') : '';
    },
  },
  methods: {
    onInput() {
      this.$refs.showDateMenu.save(this.date);
      this.$emit('input', this.date);
    },
  },
};
</script>

<template>
  <div class="rbx-date-picker">
    <v-menu
      ref="showDateMenu"
      :close-on-content-click="false"
      v-model="showDateMenu"
      :return-value.sync="date"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px">
      <v-text-field
        slot="activator"
        v-model="formattedDate"
        :selected="formattedDate"
        :label="label"
        prepend-icon="event"
        readonly
        height="22"
        class="caption" />
      <v-date-picker
        v-model="date"
        no-title
        locale="de"
        @input="onInput()" />
    </v-menu>
  </div>
</template>

<style lang="scss">
</style>
